import { createContext, useContext } from 'react';

const PlanTakeoffContext = createContext(null);

export const PlanTakeoffProvider = ({ value, children }) => (
  <PlanTakeoffContext.Provider value={value}>
    {children}
  </PlanTakeoffContext.Provider>
);

export const usePlanTakeoff = () => {
  const ctx = useContext(PlanTakeoffContext);
  if (!ctx) {
    throw new Error('usePlanTakeoff must be used within a PlanTakeoffProvider');
  }
  return ctx;
};

export default PlanTakeoffContext;
